import {
  MessageSquare,
  PlusCircle,
  Layers,
  Bot,
  Users,
  Wrench,
  GitBranch,
  Clock,
} from 'lucide-react';

export const NavData = [
  {
    path: 'dashboard',
    file: 'new-chat',
    Icon: MessageSquare,
    name: 'Jose Chat',
    haskey: true,
  },
  {
    path: 'create-agent',
    file: 'create-agent',
    Icon: PlusCircle,
    name: 'Create Agent',
    haskey: true,
  },
  {
    path: 'projects',
    file: 'projects',
    Icon: Layers,
    name: 'Projects',
  },
  {
    path: 'agents',
    file: 'agents',
    Icon: Bot,
    name: 'Agents',
  },
  {
    path: 'team',
    file: 'team',
    Icon: Users,
    name: 'Team',
  },
  {
    path: 'tools',
    file: 'tools',
    Icon: Wrench,
    name: 'Tools',
  },
  {
    path: 'workflows',
    file: 'create-workflow',
    Icon: GitBranch,
    name: 'Workflows',
  },
  {
    path: 'task-manager',
    file: 'task-manager',
    Icon: Clock,
    name: 'Task Manager',
  },
];
